import { ContactSuccessIcon } from '@/components/Icons'

export const SuccessMessage = ({ message }) => (
  <div className='text-center flex flex-col items-center justify-center gap-6'>
    <ContactSuccessIcon className='mb-2 mx-auto' />
    <p className='mx-auto max-w-[552px] text-default-600 font-bold text-lg text-balance'>{message}</p>
  </div>
)
